import React, { useEffect, useState, useCallback } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import '../../fonts/fonts.css'
import SideBar from '../SideBar'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import injectSaga from '../../utils/injectSaga'
import { simuPlayerEditData, deleteSimuPlayerSaga } from './saga'
import { simuPlayerEdit, deleteSimuPlayer, hideModal } from '../App/actions'
import PageHeader from '../../components/PageHeader'
import pen from '../../images/pen.svg'
import ModalConfirm from '../../components/ModalConfirm'
import config from '../../config/configurator'
import {
  Bg, MainLayout, MainContainer, DashboardContainer,
  FormCard, Divider, SectionTitle, TwoCol,
  FieldGroup, FieldLabel, Input, FeedBack,
  SelectorAgencyContainer, SelectorLicenceContainer,
  AgencySelector, LicenceSelector,
  ButtonContainer, DeleteBtn, SaveBtn,
  SuccessToast,
} from './styledComponents'
import Dashboard from '../../components/Dashboard'
import InfoContainer from '../../components/SimuPlayer_InfoContainer'

const PlayerEdit = (props) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const players = useSelector((state) => state.toJS().global.simuPlayers)
  const error = useSelector((state) => state.toJS().global.error)
  const loading = useSelector((state) => state.toJS().global.loading)
  const token = useSelector((state) => state.toJS().global.agencytoken)
  const agencies = useSelector((state) => state.toJS().global.agencies)
  const isAdmin = useSelector((state) => state.toJS().global.isAdmin)
  const successStore = useSelector((state) => state.toJS().global.success)

  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  const player = players ? players.find(player => player.id === id || player._id === id) : ''

  const [success, setSuccess] = useState()
  const [password, setPassword] = useState('')
  const [repPassword, setRepPassword] = useState('')
  const [wrongRepeat, setWrongRepeat] = useState('')
  const [playerId, setPlayerId] = useState(id)
  const [playerAgency, setPlayerAgency] = useState(player.agencyId)
  const [firstname, setFirstname] = useState(player.firstname)
  const [lastname, setLastname] = useState(player.lastname)
  const [email, setEmail] = useState(player.email)
  const [borderColor, setBorderColor] = useState()
  const [modalName, setModalName] = useState()
  const [modalText, setModalText] = useState()
  const [verif, setVerif] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [warn, setWarn] = useState({ lastname: false, firstname: false, mail: false, psw: false, repPsw: false, error: false })
  const [showModal, setShowModal] = useState(false)
  const [errorCode, setErrorCode] = useState(0)
  const [playerLicence, setPlayerLicence] = useState(player.trainingType || '')

  useEffect(() => {
    displayModal(successStore)
    errorCheck(error)
    // eslint-disable-next-line
  }, [player._id, loading, successStore, error])

  const errorCheck = (err) => {
    if (err) {
      switch (error) {
        case "Failed to fetch":
          setSuccess(false); setWarn({ error: true }); setModalText('Impossible d\'accéder au serveur'); setErrorCode(error)
          break
        default:
          setSuccess(false); setWarn({ error: true }); setModalText('Erreur'); setErrorCode(error)
      }
    }
  }

  const displayModal = (show) => {
    if(show){
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
      }, 2000);
    }
  }

  const handleClick = () => {
    dispatch(simuPlayerEdit({ id, firstname: firstname, lastname: lastname, email: email, password: password, agencyid: playerAgency, token: token, type: location.state, trainingType: playerLicence }))
    reset()
  }

  const reset = () => {
    setPassword('')
    setRepPassword('')
    setVerif(false)
  }

  const verification = () => {
    if (lastname && firstname && email && (password === repPassword)) {
      if(password && repPassword !== null){
        if (!emailCheck()) {
          setVerif(true)
        }
      }
    } else {
      setVerif(false)
    }
  }

  const onKeyPress = event => {
    if (event.key === 'Enter') {
      if (verif) { handleClick() }
    }
  }

  function handleChangeAgency (e) {
    setPlayerAgency(e.value)
    setVerif(true)
  }

  function displayAgencySelector () {
    if (agencies && player) {
      const agencyValues = []
      agencies.forEach((ag) => agencyValues.push({ value: ag.agencyId, label: ag.agencyName }))
      let currentAgencyIndex = agencyValues.indexOf(agencyValues.find((ag) => ag.value === player.agencyId))

      return (
        <AgencySelector
          classNamePrefix='react-select'
          multiple={false}
          isSearchable={false}
          defaultValue={agencyValues[currentAgencyIndex]}
          placeholder={'Aucune agence'}
          onChange={(e) => {handleChangeAgency(e)}}
          options={agencyValues}
        />
      )
    } else {
      return null
    }
  }

  function handleChangeLicence (e) {
    setPlayerLicence(e ? e.value : '')
    setVerif(true)
  }

  const licences = [
    { value: 'B', label: 'B' },
    { value: 'BEA', label: 'BEA' },
    { value: 'AAC', label: 'AAC' },
    { value: 'BEA AAC', label: 'BEA AAC' }
  ]

  const DisplayLicenceSelector = () => {
    const currentLicence = licences.find((li) => li.value === playerLicence) || null
    return (
      <LicenceSelector
        classNamePrefix='react-select'
        isSearchable={false}
        value={currentLicence}
        placeholder='Sélectionnez un permis ...'
        onChange={(e) => { handleChangeLicence(e) }}
        options={licences}
      />
    )
  }

  const emailCheck = () => {
    if (!email) { return }
    const expReg = /\S+@\S+\.\S+/
    const result = email.match(expReg)
    if (result == null) {
      setBorderColor('#FF0000')
      setWarn({ mail: true })
      setEmailError('Mail non valide')
      return true
    }
    setBorderColor('#B3ABBC')
    setWarn({ mail: false })
    return false
  }

  function confirmDelete (id, action, firstname) {
    setShowModal(true)
    setPlayerId(id)
    setModalText(`${action}`)
    setModalName(`${firstname}`)
  }

  const deletePlayer = (id) => {
    dispatch(deleteSimuPlayer(token, id, playerAgency))
    setTimeout(() => {
      history.push('/simuplayers')
    }, 100)
  }

  const handleChangePassword = useCallback ((event) => {
    const pass = event.target.value
    setPassword(pass)
  }, [])

  const handleChangeRepPassword = useCallback ((event) => {
    const repPass = event.target.value
    setRepPassword(repPass)
  }, [])

  const checkPassword = () => {
    if (repPassword && password && (repPassword !== password)) {
      setWrongRepeat(true)
    } else {
      setWrongRepeat(false)
    }
  }

  const isReadOnly = config.title === 'ECF' || config.title === 'PP ADMIN'

  if (!player.firstname) {
    return <div>LOADING</div>
  }

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        {success && <SuccessToast>✓ L'élève a bien été modifié !</SuccessToast>}
        <ModalConfirm
          show={showModal}
          confirmText='Supprimer'
          text={modalText}
          name={modalName}
          confirm={() => deletePlayer(playerId)}
          cancel={() => setShowModal(false)}
        />
        <PageHeader
          icon={pen}
          title='Le compte élève'
          subtitle={player.firstname ? `${player.firstname} ${player.lastname}` : 'Modifier le profil'}
        />

        <MainContainer>
          <DashboardContainer>
            <Dashboard height='48px' type='edit' data={{ firstName: firstname, lastName: lastname }} />
          </DashboardContainer>

          <InfoContainer path={location.pathname} playerId={id} />

          <FormCard>

            {/* ── Agence (admin uniquement) ── */}
            {isAdmin && (
              <>
                <div>
                  <SectionTitle>Agence</SectionTitle>
                  <SelectorAgencyContainer>
                    {displayAgencySelector()}
                  </SelectorAgencyContainer>
                </div>
                <Divider />
              </>
            )}

            {/* ── Informations personnelles ── */}
            <div>
              <SectionTitle>Informations personnelles</SectionTitle>
              <TwoCol>
                <FieldGroup>
                  <FieldLabel>Nom</FieldLabel>
                  <Input
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    autoComplete='off'
                    value={lastname}
                    style={{ backgroundColor: isReadOnly ? '#F9FAFB' : 'white' }}
                    onKeyUp={() => verification()}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </FieldGroup>
                <FieldGroup>
                  <FieldLabel>Prénom</FieldLabel>
                  <Input
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                    autoComplete='off'
                    value={firstname}
                    style={{ backgroundColor: isReadOnly ? '#F9FAFB' : 'white' }}
                    onKeyUp={() => verification()}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </FieldGroup>
              </TwoCol>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Email</FieldLabel>
                <Input
                  readOnly={isReadOnly}
                  disabled={isReadOnly}
                  autoComplete='off'
                  value={email}
                  style={{ borderColor: borderColor, backgroundColor: isReadOnly ? '#F9FAFB' : 'white' }}
                  onKeyUp={() => verification()}
                  onChange={(e) => { setEmail(e.target.value); emailCheck() }}
                />
                {warn.mail && <FeedBack>{emailError}</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Mot de passe ── */}
            <div>
              <SectionTitle>Changer le mot de passe</SectionTitle>
              <FieldGroup>
                <FieldLabel>Nouveau mot de passe</FieldLabel>
                <Input
                  autoComplete='off'
                  value={password}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onKeyUp={() => { verification(); checkPassword() }}
                  onKeyPress={onKeyPress}
                  onChange={(e) => handleChangePassword(e)}
                />
              </FieldGroup>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Répéter le mot de passe</FieldLabel>
                <Input
                  autoComplete='off'
                  value={repPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onKeyUp={() => { verification(); checkPassword() }}
                  onKeyPress={onKeyPress}
                  onChange={(e) => handleChangeRepPassword(e)}
                />
                {wrongRepeat && <FeedBack>Les mots de passe ne correspondent pas</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Permis ── */}
            <div>
              <SectionTitle>Permis</SectionTitle>
              <SelectorLicenceContainer>
                {DisplayLicenceSelector()}
              </SelectorLicenceContainer>
            </div>

            <Divider />

            {/* ── Actions ── */}
            <ButtonContainer>
              <DeleteBtn onClick={() => confirmDelete(id, 'Attention, vous allez supprimer définitivement le compte de ', (firstname + ' ' + lastname))}>
                Supprimer
              </DeleteBtn>
              <SaveBtn disabled={!verif} onClick={() => handleClick()}>
                Enregistrer les modifications
              </SaveBtn>
            </ButtonContainer>

            {warn.error && (
              <FeedBack style={{ textAlign: 'center' }}>{modalText}</FeedBack>
            )}

          </FormCard>
        </MainContainer>
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'simuPlayerEdit', saga: simuPlayerEditData })
const withDeleteSaga = injectSaga({ key: 'deleteSimuPlayer', saga: deleteSimuPlayerSaga })

const arg = compose(withSaga, withDeleteSaga, withConnect)(PlayerEdit)

export default arg
